export const parsePage = (page: string | undefined = ''): number => {
  const pageInt = parseInt(page);
  return Number.isNaN(pageInt) || pageInt < 1 ? 1 : pageInt;
};
